import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchAssortmentGroups } from '../api/fetchAssortmentGroups'
import { REQUEST_ASSORTMENT_GROUPS } from '../constants'

export const requestAssortmentGroups = createAsyncThunk(
  REQUEST_ASSORTMENT_GROUPS,
  fetchAssortmentGroups
)
